// extracted by mini-css-extract-plugin
export default {"NavItemVertical":"NavItemVertical_NavItemVertical__ahP15","Label":"NavItemVertical_Label__KYT7G","isCollapsed":"NavItemVertical_isCollapsed__cTWA+"};